import { createFileRoute } from '@tanstack/react-router';
import GroupEdit from '../../../features/management/groups/group/edit';
import {
  createPermissionGuard,
  getPermissionSet,
  GROUP_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/verwaltung/gruppen/$groupId_/bearbeiten',
)({
  component: GroupEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GROUP_MANAGEMENT_PERMISSIONS, 'EDIT'),
  ),
});

export const EditGroupRoute = Route;
